import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BuildingIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M1 8.344V31h8.75V6.703L1 8.343ZM7.25 28.5H3.5V26h3.75v2.5Zm0-5H3.5V21h3.75v2.5Zm0-5H3.5V16h3.75v2.5Zm0-5H3.5V11h3.75v2.5Zm5-12.5v30H31V4.516L12.25 1Zm7.5 27.5H16V26h3.75v2.5Zm0-5H16V21h3.75v2.5Zm0-5H16V16h3.75v2.5Zm0-5H16V11h3.75v2.5Zm0-5H16V6h3.75v2.5Zm7.5 20H23.5V26h3.75v2.5Zm0-5H23.5V21h3.75v2.5Zm0-5H23.5V16h3.75v2.5Zm0-5H23.5V11h3.75v2.5Z"
      />
    </BaseIcon>
  );
}
